<dx-popup
  [attr.data-test-id]="'preview-file-popup'"
  id="photo-popup"
  maxHeight="600"
  class="show-close-button"
  hideOnOutsideClick="true"
  showCloseButton="true"
  (onHiding)="hidePopup()"
  [(title)]="titleToDisplay"
  [(visible)]="popupVisible"
>
  <div *dxTemplate="let data of 'content'" class="photo-popup-content">
    <img
      *ngIf="contentType === content.IMAGE_TYPE && protectedPublicURL"
      [src]="protectedPublicURL"
      data-test-id="image-popup"
      class="photo-popup-image"
      alt="{{ titleToDisplay }}"
    />
    <iframe
      *ngIf="contentType === content.PDF_TYPE"
      data-test-id="pdf-popup"
      [src]="protectedPublicURL"
      width="100%"
      height="800"
      frameborder="0"
    ></iframe>

    <video
      *ngIf="contentType === content.VIDEO_TYPE"
      [src]="protectedPublicURL"
      controls
      autoplay
      class="video-frame"
      data-test-id="video-popup"
    ></video>

    <audio
      *ngIf="contentType === content.AUDIO_TYPE"
      [src]="protectedPublicURL"
      controls
      autoplay
      class="audio-frame"
      data-test-id="audio-popup"
    >
      <a [href]="protectedPublicURL">{{ 'DOWNLOAD_AUDIO' | translate }}</a>
    </audio>

    <div *ngIf="contentType === content.IMAGE_TYPE && !protectedPublicURL" class="photo-popup-image">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{ 'LOADING_HINT' | translate }}</span>
      </div>
    </div>
  </div>
</dx-popup>
